<template>
  <div class="col-12 col-md-6 pa-0" :class="[question?.StyleClass]">
    <HomeBaseInputDate
      :questionObject="question"
      :label="question.Text"
      :labelStyle="question.LabelStyleClass"
      :helpText="question.HelpText"
      :validation="question.Validation"
      :styleClass="question.StyleClass"
      :interfaceKey="question.InterfaceKey"
      :hideDetails="question.HideDetails"
    />
  </div>
</template>
<script lang="js">
//Wrapper for question using HomeBaseInputDate
import HomeBaseInputDate from "@/components/HomeComponents/HomeBaseComponents/HomeBaseInputDate";
export default {
  name: "QuestionDate",
  components: {
    HomeBaseInputDate
  },
  props: {
    question: {
      type: Object,
      required: true,
    }
  },
};
</script>
<style lang="scss" scoped></style>
